export const MODULE_TLPE = 'Tlpe';

export const NOTHING = null;
